import { render, staticRenderFns } from "./navbar-regular.vue?vue&type=template&id=8ec74fac&scoped=true&"
import script from "./navbar-regular.vue?vue&type=script&lang=js&"
export * from "./navbar-regular.vue?vue&type=script&lang=js&"
import style0 from "./navbar-regular.vue?vue&type=style&index=0&id=8ec74fac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec74fac",
  null
  
)

export default component.exports